import React, { useEffect,useState } from "react";
import "../../css/header-menu/PowerManagement.css";
import Header from "../Home/header";
import Footer from "../Home/footer";
import Promotion from "../Home/Promotion";


function ProductCard({ title, subtitle, features, imgSrc, imgPosition = "left"}) {
    const titleAnimClass = imgPosition === "left" ? "animate-from-right" : "animate-from-left";
    const paragraphAnimClass = "animate-from-bottom";

    return (
        <div className="Row">
            <div className="content-wrapper">
                {imgPosition === "left" && (
                    <div className="half image-container">
                        <img className="imagesForPower" src={imgSrc} alt="Station" />
                    </div>
                )}
                <div className="half">
                    <div className="Column">
                        <h1 className="HomeProductionsText hidden" data-anim={titleAnimClass}>{title}</h1>
                        <h3 className="subtitle hidden" data-anim={titleAnimClass}>{subtitle}</h3>
                        <ul className="features-list hidden" data-anim={paragraphAnimClass}>
                            {features.map((feature, index) => (
                                <li key={index}>{feature}</li>
                            ))}
                        </ul>
                        
                    </div>
                </div>
                {imgPosition === "right" && (
                    <div className="half image-container">
                        <img className="imagesForPower" src={imgSrc} alt="Station" />
                    </div>
                )}
            </div>
        </div>
    );
}


function PowerManagementList() {
    const images = {
        second: "/assets/home/PowerManagment/image.png",
        first: "/assets/home/PowerManagment/smartpower.png",
        third: "/assets/home/PowerManagment/third kopya.jpg"
    };
    const First = "Enerji Kullanımında Maksimum Verimlilik"
    const Second = "Enerji Altyapınızı Koruyun"
    const Third = "Sürdürülebilir Gelecek İçin Enerji Yönetimi"
    const FirstSubline = "Akıllı güç yönetimi, mevcut enerji tüketiminizi analiz ederek şarj gücünü otomatik olarak ayarlar. Böylece evinizdeki diğer cihazların çalışmasını etkilemeden aracınızı güvenli ve verimli bir şekilde şarj edebilirsiniz."
    const SecondSubline = "Güç yönetim sistemi, mevcut elektrik altyapınızın sınırlarını zorlamadan çalışır. Elektrik kesintisi veya aşırı yüklenme riskini azaltarak uzun vadede altyapı maliyetlerini düşürür."
    const ThirdSubline = "Akıllı güç yönetimi, enerjiyi verimli kullanarak karbon ayak izinizi azaltmanıza yardımcı olur. Yenilenebilir enerji kaynakları ile entegre çalışabilen sistemimiz, çevre dostu bir şarj deneyimi sunar."
    useEffect(() => {
        
        const hiddenElements = document.querySelectorAll('.hidden');
        const observer = new IntersectionObserver((entries) => {
            entries.forEach(entry => {
                const animClass = entry.target.getAttribute('data-anim');
                if (entry.isIntersecting) {
                    // Görünür alana girdi
                    entry.target.classList.remove('hidden');
                    if (animClass) {
                        entry.target.classList.add(animClass);
                    }
                } else {
                    // Görünür alandan çıktı
                    // Tekrar animasyon yapmak için tekrar .hidden ekleyip animClass'ı kaldırıyoruz.
                    entry.target.classList.add('hidden');
                    if (animClass) {
                        entry.target.classList.remove(animClass);
                    }
                }
            });
        }, {
            threshold: 0.1
        });

        hiddenElements.forEach(el => observer.observe(el));

        return () => {
            observer.disconnect();
        };
    }, []);
    return (
        <>
            <Header />
            <Promotion
                Header="Akıllı Güç Yönetimi: Enerjinizi Verimli Kullanın"
                Footer="Akıllı Güç Yönetimi teknolojisi sayesinde şarj istasyonlarınız enerji kullanımını optimize ederek hem tasarruf sağlar hem de elektrik altyapınızı korur."
                Footer2="Dap Şarj olarak Akıllı Güç Yönetimi Teknolojisini sizlerle uygulayarak geleceği beraber inşaa edelim."
            />
            <PowerManagementVideo />

            <ProductCard
                title={First}
                subtitle={FirstSubline}
                features={[
                    "Dinamik Yük Dengeleme: Evinizdeki toplam enerji tüketimini izler ve şarj gücünü otomatik olarak sınırlar.",
                    "Anlık Tüketim Takibi: Gerçek zamanlı enerji verisi ile şarj sürecinizi kolayca kontrol edin."
                ]}
                imgSrc={images.first}
                imgPosition="left"
            />
            <ProductCard
                title={Second}
                subtitle={SecondSubline}
                features={["Güvenli Şarj Deneyimi: Elektrik devrelerinde aşırı yüklenmeyi önleyen akıllı sistemler ile güvenliği maksimum seviyeye çıkarın.", "Optimum Şarj Süreleri: En uygun saatlerde şarj ederek hem enerjiden tasarruf edin hem de elektrik faturalarınızı azaltın."]}

                imgPosition="right"
                imgSrc={images.second}
            />
            <ProductCard
                title={Third}
                subtitle={ThirdSubline}
                features={["Güneş Enerjisi Entegrasyonu: Eğer güneş panelleriniz varsa, şarj istasyonunuz güneşten gelen enerjiyi öncelikli olarak kullanır.", "Akıllı Zamanlama: Düşük enerji tarifelerinin olduğu saatlerde şarj planlaması yaparak maliyetlerinizi minimuma indirin."]}
                imgPosition="left"
                imgSrc={images.third}
            />
            <Footer />
        </>
    );
}

const PowerManagementVideo = () => {
    const [videoSource, setVideoSource] = useState('');

    useEffect(() => {
        const handleResize = () => {
            const isMobile = window.innerWidth <= 768;
            const baseUrl = process.env.PUBLIC_URL;
            setVideoSource(
                isMobile 
                    ? `${baseUrl}/assets/videos/charge_animation_mobile.mp4`
                    : `${baseUrl}/assets/videos/charge_animation.mp4`
            );
        };

        handleResize(); // İlk yükleme için
        window.addEventListener('resize', handleResize);
        
        return () => window.removeEventListener('resize', handleResize);
    }, []);

    return (
        <div className="power-video-wrapper">
            {videoSource && (
                <video 
                    key={videoSource} // Kaynak değiştiğinde video yeniden yüklenir
                    autoPlay 
                    loop 
                    muted 
                    playsInline
                    className="power-management-video"
                    disablePictureInPicture
                    controlsList="nodownload noplaybackrate"
                    style={{ backgroundColor: 'transparent' }}
                    src={videoSource}
                />
            )}
        </div>
    );
};
export default PowerManagementList;